import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { CsatReportFilters, CsatReportQuery } from '@troia-v3/types';

import { csatReportApi } from '../services/csatReportApi';

export const csatReportKeys = {
  all: ['csat-report'] as const,
  list: (query: CsatReportQuery) => ['csat-report', 'list', query] as const,
  summary: (filters: CsatReportFilters) => ['csat-report', 'summary', filters] as const,
};

/**
 * Página do relatório. `keepPreviousData`: trocar de página ou de filtro não
 * pisca a tabela vazia enquanto a próxima chega.
 */
export const useCsatReport = (query: CsatReportQuery) =>
  useQuery({
    queryKey: csatReportKeys.list(query),
    queryFn: () => csatReportApi.list(query),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });

/** Resumo do recorte — o servidor ignora situação e nota. */
export const useCsatSummary = (filters: CsatReportFilters) =>
  useQuery({
    queryKey: csatReportKeys.summary(filters),
    queryFn: () => csatReportApi.summary(filters),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
